export const assistanceFrequency: { [key: string]: string } = {
  REGULAR: "Regular",
  UNIQUE: "Única"
};
